<template>
  <aha-icon
    :name="logoType"
    :maintainColor="useDefaultColor"
  />
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    iconOnly: {
      type: Boolean,
      default: false,
    },
    useDefaultColor: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    logoType() {
      return this.iconOnly ? 'logo-icon-only' : 'logo'
    },
  },
}
</script>

<style lang="scss">
.path-fill-current path {
  @apply fill-current;
}
</style>
